<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="fitnessGoal.id === null">{{ 'NEWFITNESSGOAL' | translate }}</span>
            <span *ngIf="fitnessGoal.id !== null">{{ 'EDITFITNESSGOAL' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="fitnessGoalForm" id="fitnessGoalForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="fitnessGoalForm" >
            <input type="hidden" name="id" id="fitnessGoalId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessGoalName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="fitnessGoalName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="fitnessGoalForm.controls['name'].invalid && (fitnessGoalForm.controls['name'].dirty || fitnessGoalForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessGoalForm.controls['name'].errors !== null">
                  <div *ngIf="fitnessGoalForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessGoalNameAr" formControlName="nameAr" type="text" pInputText [required]="false"> 
                      <label for="fitnessGoalNameAr" class="">{{ 'NAMEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessGoalNameFr" formControlName="nameFr" type="text" pInputText [required]="false"> 
                      <label for="fitnessGoalNameFr" class="">{{ 'NAMEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-info-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessGoalDescription" formControlName="description" type="text" pInputText [required]="false"> 
                      <label for="fitnessGoalDescription" class="">{{ 'DESCRIPTION' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-align-justify"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessGoalDescriptionAr" formControlName="descriptionAr" type="text" pInputText [required]="false"> 
                      <label for="fitnessGoalDescriptionAr" class="">{{ 'DESCRIPTIONAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-align-justify"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessGoalDescriptionFr" formControlName="descriptionFr" type="text" pInputText [required]="false"> 
                      <label for="fitnessGoalDescriptionFr" class="">{{ 'DESCRIPTIONFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <span class="p-float-label">
                    <textarea id="fitnessGoalLongDescription" formControlName="longDescription" [rows]="5" [cols]="30" pInputTextarea [autoResize]="true" [required]="false"></textarea>
                    <label for="fitnessGoalLongDescription" class="">{{ 'LONGDESCRIPTION' | translate }}</label>
                  </span>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <span class="p-float-label">
                    <textarea id="fitnessGoalLongDescriptionAr" formControlName="longDescriptionAr" [rows]="5" [cols]="30" pInputTextarea [autoResize]="true" [required]="false"></textarea>
                    <label for="fitnessGoalLongDescriptionAr" class="">{{ 'LONGDESCRIPTIONAR' | translate }}</label>
                  </span>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <span class="p-float-label">
                    <textarea id="fitnessGoalLongDescriptionFr" formControlName="longDescriptionFr" [rows]="5" [cols]="30" pInputTextarea [autoResize]="true" [required]="false"></textarea>
                    <label for="fitnessGoalLongDescriptionFr" class="">{{ 'LONGDESCRIPTIONFR' | translate }}</label>
                  </span>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-icons "></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessGoalIcon" formControlName="icon" type="text" pInputText [required]="false"> 
                      <label for="fitnessGoalIcon" class="">{{ 'ICON' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('icon')"></button> 
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessGoalPicture" formControlName="picture" type="text" pInputText [required]="false"> 
                      <label for="fitnessGoalPicture" class="">{{ 'PICTURE' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('picture')"></button> 
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="fitnessGoalIsPublished" formControlName="isPublished" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="fitnessGoalIsPublished" class="p-d-inline-block p-ml-2 req">{{ 'ISPUBLISHED' | translate }}</label>
                </div>
                <div *ngIf="fitnessGoalForm.controls['isPublished'].invalid && (fitnessGoalForm.controls['isPublished'].dirty || fitnessGoalForm.controls['isPublished'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessGoalForm.controls['isPublished'].errors !== null">
                  <div *ngIf="fitnessGoalForm.controls['isPublished'].errors.required">
                   {{ 'ISPUBLISHEDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKFITNESSGOALS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="fitnessGoal.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!fitnessGoalForm.valid || disableSubmit"> <!--  [disabled]="fitnessGoalForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!fitnessGoalForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

